import { setFilterValue } from "./index";
import { convertValueToInteger } from "../utils";
import { queryParams } from "../queryParams";
import { updateQueryParam } from "../../../../../../../magnolia-component-library/assets/js/utils/queryParams";
import { scrollToElement } from "../../../../../../../magnolia-component-library/assets/js/utils/smooth-scroll";
import { mediaMin } from "../../../../../../../magnolia-component-library/assets/js/utils/breakpoints";

const classNames = {
    active: "el__pagination-item--active",
    show: "el__pagination-item--show",
    current: "el__pagination-item--current",
};

export const handlePaginationClick = (filterObj, e) => {
    const { value, pagesCount } = filterObj;

    const target =
        e.target instanceof HTMLButtonElement
            ? e.target
            : e.target.parentElement instanceof HTMLButtonElement
            ? e.target.parentElement
            : null;

    if (!target) return value;

    scrollToElement(".el", null, false);

    const pageIndex = convertValueToInteger(target.dataset.page);
    const direction = target.dataset.direction;

    if (pageIndex) return pageIndex;

    if (!direction || !value) return;

    if (direction === "prev" && value - 1 > 0) return value - 1;

    if (direction === "next" && pagesCount && value + 1 <= pagesCount) return value + 1;

    return value;
};

export const paginationFilterHandler = (extensions, filterObj) => {
    if (!filterObj.value || !filterObj.perPage) extensions;

    let { value, perPage } = filterObj;

    const pagesCount = Math.ceil(extensions.length / parseInt(perPage, 10)) || 1;
    setFilterValue(filterObj, "pagesCount", pagesCount);

    if (value > pagesCount) {
        value = 1;
        setFilterValue(filterObj, "value", value);
        updateQueryParam(queryParams, filterObj.filterName, value);
    }

    updatePaginationUI(filterObj);

    const startIndex = value * perPage - perPage;
    const endIndex = startIndex + perPage;

    return extensions.slice(startIndex, endIndex);
};

const fillPaginationValue = (filterEl, value, classState) => {
    const filterValueEl = filterEl.querySelector(`.el__filter-value[data-page="${value}"]`);

    if (filterValueEl) filterValueEl.parentElement.classList[classState](classNames.current);
};

export const setPaginationValue = (filterEl, value) => fillPaginationValue(filterEl, value, "add");

export const resetPaginationValue = (filterEl, value) => fillPaginationValue(filterEl, value, "add");

const updatePaginationUI = (filterObj) => {
    if (!filterObj.maxPages || !filterObj.pagesCount) return;

    const { maxPages, pagesCount, filterEl } = filterObj;
    const numbersListItems = getListItems(filterEl, "numbers");
    const numbersListBoundaries = getNumbersListBoundaries(maxPages);
    const trueIndex = filterObj.value - 1;
    let pagesShown = 0;
    let leftOvers = 0;

    if (numbersListItems.length === 0) return;

    resetListItemsClasses(numbersListItems);
    activateListItems(numbersListItems, pagesCount);

    // Show the current page
    numbersListItems[trueIndex].classList.add(classNames.show);
    numbersListItems[trueIndex].classList.add(classNames.current);
    pagesShown += 1;

    // Show the previous pages
    for (let i = trueIndex - 1; i >= 0; i--) {
        if (!numbersListItems[i] || !numbersListItems[i].classList.contains(classNames.active)) break;

        // Show maxium of 2 before the current one
        if (pagesShown > numbersListBoundaries.prev) {
            leftOvers += 1;
        } else {
            numbersListItems[i].classList.add(classNames.show);
            pagesShown += 1;
        }
    }

    updateControlButtons(filterEl, "prev", trueIndex === 0, !!leftOvers);

    // Show the next pages
    leftOvers = 0;

    for (let i = trueIndex + 1; i < numbersListItems.length; i++) {
        if (!numbersListItems[i] || !numbersListItems[i].classList.contains(classNames.active)) break;

        // Show maxium of 2 after the current one
        if (pagesShown >= numbersListBoundaries.next) {
            leftOvers += 1;
        } else {
            numbersListItems[i].classList.add(classNames.show);
            pagesShown += 1;
        }
    }

    updateControlButtons(filterEl, "next", trueIndex + 1 === pagesCount, !!leftOvers);
};

const getListItems = (filterEl, className) =>
    filterEl.querySelectorAll(`.el__pagination-list--${className} li`);

const activateListItems = (listItems, pagesCount) => {
    for (let i = 0; i < listItems.length; i++) {
        if (listItems[i] && i < pagesCount) listItems[i].classList.add(classNames.active);
    }
};

const resetListItemsClasses = (listItems) => {
    for (const listItem of listItems) {
        for (const className of Object.values(classNames)) {
            if (listItem.classList.contains(className)) listItem.classList.remove(className);
        }
    }
};

const updateControlButtons = (filterEl, listClassName, disableDirectionButton, showMoreButton) => {
    const listItems = getListItems(filterEl, listClassName);

    if (listItems.length === 0) return;

    const controlButtonsConfig = {
        directionButton: {
            className: "el__pagination-item--direction",
            conditition: disableDirectionButton,
        },
        moreButton: {
            className: "el__pagination-item--more",
            conditition: showMoreButton,
        },
    };

    for (const listItem of listItems) {
        for (const [key, value] of Object.entries(controlButtonsConfig)) {
            if (!listItem.classList.contains(value.className)) continue;

            if (key === "moreButton") {
                listItem.classList[value.conditition ? "add" : "remove"](classNames.active);
            } else {
                const button = listItem.querySelector(`.el__pagination-button--${listClassName}`);

                if (button) button.disabled = value.conditition;
            }
        }
    }
};

const getNumbersListBoundaries = (maxPages) => {
    const pagesToShow = (maxPages - 1) / 2; // (maxPages - current one) / each side

    // For mobile
    if (!mediaMin("lg") && pagesToShow > 1)
        return {
            prev: pagesToShow - 1,
            next: pagesToShow + 1,
        };

    return {
        prev: pagesToShow,
        next: maxPages,
    };
};
